module.exports = __webpack_public_path__ + "static/img/space.39adb7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/space.gif
// module id = CKvG
// module chunks = 0